import 'reflect-metadata'

export class BaseModel {
  constructor(params: any = {}) {
    Object.assign(this, params)
    this.deserializeBelongsTo(params)
    this.deserializeHasMany(params)
    this.deserializeAttribute(params)
  }

  private deserializeBelongsTo(params: any) {
    const belongsTo: any = Reflect.getMetadata('BelongsTo', this)

    if (belongsTo) {
      for (const metadata of belongsTo) {
        const param = params[metadata.relationship]
        this[metadata.relationship] = param ? new metadata.class(param) : null
      }
    }
  }

  private deserializeHasMany(params: any) {
    const hasMany: any = Reflect.getMetadata('HasMany', this)

    if (hasMany) {
      for (const metadata of hasMany) {
        const list: any[] = params[metadata.relationship] || []
        this[metadata.relationship] = list.map((param) => new metadata.class(param))
      }
    }
  }

  private deserializeAttribute(params: any) {
    const attribute: any = Reflect.getMetadata('Attribute', this)

    if (attribute) {
      for (const metadata of attribute) {
        const param = params[metadata.relationship]
        this[metadata.relationship] = param ? new metadata.class(param) : null
      }
    }
  }
}

export type ModelType<T extends BaseModel> = { new(params: any): T }

// https://github.com/ghidoz/angular2-jsonapi/blob/master/src/decorators/belongs-to.decorator.ts
export function BelongsTo<T>(klass: T) {
  return function (target: any, propertyName: string | symbol) {
    const annotations = Reflect.getMetadata('BelongsTo', target) || []

    annotations.push({
      propertyName,
      relationship: propertyName,
      class: klass
    })

    Reflect.defineMetadata('BelongsTo', annotations, target)
  }
}

// An alias of BelongsTo
export function HasOne<T>(klass: T) {
  return BelongsTo(klass)
}

// https://github.com/ghidoz/angular2-jsonapi/blob/master/src/decorators/has-many.decorator.ts
export function HasMany<T>(klass: T) {
  return function (target: any, propertyName: string | symbol) {
    const annotations = Reflect.getMetadata('HasMany', target) || []

    annotations.push({
      propertyName,
      relationship: propertyName,
      class: klass
    })

    Reflect.defineMetadata('HasMany', annotations, target)
  }
}

export function Attribute<T>(klass: T) {
  return function (target: any, propertyName: string | symbol) {
    const annotations = Reflect.getMetadata('Attribute', target) || []

    annotations.push({
      propertyName,
      relationship: propertyName,
      class: klass
    })

    Reflect.defineMetadata('Attribute', annotations, target)
  }
}



// WEBPACK FOOTER //
// ./src/models/base-model.ts